import React, { useMemo, useCallback } from 'react'

import { EDIT_MODES } from '../../constants'

import { useBufferEditor, useCurrentBuffersLayerIds } from '../hooks'
import { useAILayer, useAILayers } from '../../aiLayers/hooks'

import Select from '../../common/components/Select'
import Button, { BUTTON_STYLES } from '../../common/components/Button'
import TextInput from '../../common/components/TextInput'

import styles from './EditForm.module.css'

const EditForm = () => {
  const [
    { buffer, mode, isEdited },
    { save, remove, close, onChange },
  ] = useBufferEditor()
  const layer = useAILayer(buffer.layerId)
  const layers = useAILayers()
  const currentLayerIds = useCurrentBuffersLayerIds()

  const inEditMode = mode === EDIT_MODES.EDIT

  const layerOptions = useMemo(() => {
    const defaultOption = { value: -1, label: 'Select Actionable Intelligence' }
    const layer_opts = layers
      .filter((l) => !currentLayerIds.includes(l.id))
      .map((l) => ({ value: l.id, label: l.name }))
    return [defaultOption, ...layer_opts]
  }, [layers, currentLayerIds])

  const onSelectChange = useCallback(
    (value) => onChange.layerId(parseInt(value, 10)),
    [onChange]
  )

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        {inEditMode ? 'Edit' : 'Add New'} Buffer
      </div>
      <div className={styles.body}>
        {inEditMode ? (
          layer.name
        ) : (
          <Select
            value={buffer.layerId}
            onChange={onSelectChange}
            options={layerOptions}
          />
        )}
        <TextInput
          label="Distance"
          value={buffer.distance}
          type="number"
          min="1"
          onChange={onChange.distance}
        />
        <Select
          value={buffer.unit}
          label="Unit"
          onChange={onChange.unit}
          options={[
            { label: 'Miles', value: 'miles' },
            { label: 'Feet', value: 'feet' },
          ]}
        />
      </div>
      <div className={styles.footer}>
        {inEditMode && (
          <Button
            style={BUTTON_STYLES.DANGER}
            className={styles.button}
            onClick={remove}
            text="Remove"
          />
        )}
        <Button
          onClick={close}
          className={styles.button}
          text="Cancel"
          style={BUTTON_STYLES.SECONDARY}
        />
        <Button
          onClick={save}
          className={styles.button}
          icon="far fa-save"
          text={inEditMode ? 'Save' : 'Create'}
          disabled={!isEdited || buffer.layerId === -1}
          style={BUTTON_STYLES.PRIMARY}
        />
      </div>
    </div>
  )
}

export default EditForm
